var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.fullUrl}},[_c('v-row',{staticClass:"blogRow",on:{"click":_vm.goToBlog}},[_c('h1',[_vm._v(_vm._s(_vm.name))]),_c('v-spacer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }